import api from "../helpers/api";

const baseURL = process.env.REACT_APP_API_URL;

const getReportesVentas = async () => {
    const response = await api.get(`${baseURL}/reportes/resumen_ventas`);
   // console.log('esto traigo en servicio reportes:', response.data);
    return response.data;  // Aquí obtienes el objeto con `data`
}

const getReportesVentasMensuales = async () => {
    const response = await api.get(`${baseURL}/reportes/ventas_mensuales`);
   // console.log('esto traigo en servicio reportes ventas mensuales:', response.data);
    return response.data.data;  // Aquí obtienes el objeto con `data` 
}

const getRankingVentasClientes = async () => {
    const response = await api.get(`${baseURL}/reportes/ranking_ventas_clientes`);
   // console.log('esto traigo en servicio reportes ventas mensuales:', response.data);
    return response.data.data;  // Aquí obtienes el objeto con `data` 
}


const reportesService = {
    getReportesVentas,
    getReportesVentasMensuales,
    getRankingVentasClientes
}

export default reportesService;
